export { EloOwnBankIcon } from './own-bank-icon'
